import React, { useState } from "react";
import { Link } from "react-router-dom";
import Popup from "../ui/Popup";
import { BrandMark } from "../art/Icons";
import { BRAND_NAME, EVENT } from "../../config/event";
import zlinskyKrajLogo from "../../assets/zlinsky-kraj-logo-bila.svg";

const FOOTER_LINKS = [
  { key: "ochrana", label: "Ochrana duší" },
  { key: "podminky", label: "Podmínky návratu" },
  { key: "kontakt", label: "Kontakt s předky" },
];

const SoulProtection = () => (
  <>
    <div className="modal-box accent">
      <h4>Ochrana vaší duše</h4>
      <p>
        V Zemi vzpomínek bereme ochranu duší vážně. Každého návštěvníka provází La Muerte a její pomocníci, cestu
        osvětlují svíčky a lemují ji cempasúchily, které ukazují cestu zpět mezi živé.
      </p>
    </div>
    <div className="modal-grid">
      <div className="modal-box">
        <h4>Průvodci a ochrana</h4>
        <ul>
          <li>Průvodce La Muerte na každé zastávce</li>
          <li>Cesta z okvětních lístků cempasúchilu</li>
          <li>Svíčky na každém rozcestí</li>
          <li>Alebrijes hlídají brány</li>
        </ul>
      </div>
      <div className="modal-box">
        <h4>Bezpečnostní opatření</h4>
        <ul>
          <li>Neustálý dohled organizátorů</li>
          <li>Okamžitý návrat do světa živých, kdykoli o něj požádáte</li>
          <li>Pomoc pro menší odvážlivce</li>
          <li>Klidná zóna u ofrendy</li>
        </ul>
      </div>
    </div>
    <div className="modal-box">
      <h4>Důležité upozornění</h4>
      <p>
        Země vzpomínek je místem strašidelným i veselým zároveň. Kdo se bojí, může kdykoli požádat průvodce o doprovod
        zpět mezi živé.
      </p>
    </div>
  </>
);

const ReturnConditions = () => (
  <>
    <div className="modal-box accent">
      <h4>Pravidla návratu</h4>
      <p>
        Aby ses ze Země vzpomínek vrátil mezi živé, dodržuj následující podmínky. Na toho, kdo je poruší, možná
        všichni zapomenou…
      </p>
    </div>
    <div className="modal-grid">
      <div className="modal-box">
        <h4>Povinnosti návštěvníka</h4>
        <ul>
          <li>Řídit se pokyny průvodců</li>
          <li>Nerušit ofrendu ani její dary</li>
          <li>Respektovat předky i ostatní návštěvníky</li>
          <li>Dostavit se 15 minut před svým časem</li>
          <li>Uschovat si název týmu a heslo</li>
        </ul>
      </div>
      <div className="modal-box">
        <h4>Zakázané činnosti</h4>
        <ul>
          <li>Fotografovat bez svolení průvodce</li>
          <li>Dotýkat se svíček a ofrendy</li>
          <li>Opouštět trasu bez doprovodu</li>
          <li>Vyvolávat La Muerte mimo aktivity</li>
          <li>Ujídat pan de muerto z ofrendy</li>
        </ul>
      </div>
    </div>
    <div className="modal-box">
      <h4>Odpovědnost</h4>
      <p>
        Univerzita Tomáše Bati ve Zlíně neručí za náhlou touhu tančit, zpívat či vzpomínat na předky. Vstupem do Země
        vzpomínek s těmito podmínkami souhlasíte.
      </p>
    </div>
  </>
);

const AncestorContact = () => (
  <>
    <div className="modal-box accent">
      <h4>Spojení se Zemí vzpomínek</h4>
      <p>Máte dotaz k rezervaci nebo k programu? Ozvěte se průvodcům, kteří mají spojení s oběma světy.</p>
    </div>
    <div className="modal-grid">
      <div className="modal-box">
        <h4>Telefon</h4>
        <p>
          <a href={`tel:${EVENT.phone.replace(/\s/g, "")}`}>{EVENT.phone}</a>
        </p>
      </div>
      <div className="modal-box">
        <h4>E-mail</h4>
        <p>
          <a href={`mailto:${EVENT.email}`}>{EVENT.email}</a>
        </p>
      </div>
    </div>
    <div className="modal-box">
      <h4>Kde nás najdete</h4>
      <p>
        {EVENT.faculty}, {EVENT.university}
        <br />
        {EVENT.address}
        <br />
        {EVENT.date}, {EVENT.time}
      </p>
      <p className="mt-3">
        Pro rezervaci místa použijte <Link to="/reservations">rezervační formulář</Link>.
      </p>
    </div>
  </>
);

const POPUP_CONTENT = {
  ochrana: SoulProtection,
  podminky: ReturnConditions,
  kontakt: AncestorContact,
};

const Footer = () => {
  const [activePopup, setActivePopup] = useState(null);
  const ActiveContent = activePopup ? POPUP_CONTENT[activePopup] : null;
  const activeLabel = FOOTER_LINKS.find((link) => link.key === activePopup)?.label;

  return (
    <>
      <footer className="site-footer">
        <div className="foot">
          <Link className="brand" to="/">
            <BrandMark />
            {BRAND_NAME}
          </Link>
          <p>Univerzita Tomáše Bati ve Zlíně – Země vzpomínek</p>
          <nav aria-label="Informace">
            {FOOTER_LINKS.map((link) => (
              <button key={link.key} type="button" onClick={() => setActivePopup(link.key)}>
                {link.label}
              </button>
            ))}
          </nav>
          <p className="quote">„Dokud si na tebe někdo vzpomene, nikdy doopravdy neodejdeš.“</p>
          <div className="partner">
            <span>Za podpory</span>
            <a href="https://zlinskykraj.cz" target="_blank" rel="noopener noreferrer">
              <img src={zlinskyKrajLogo} alt="Zlínský kraj" width="240" height="100" />
            </a>
          </div>
        </div>
      </footer>

      <Popup isOpen={Boolean(activePopup)} onClose={() => setActivePopup(null)} title={activeLabel} wide>
        {ActiveContent && <ActiveContent />}
      </Popup>
    </>
  );
};

export default Footer;
